import { render, staticRenderFns } from "./dailyIncrease.vue?vue&type=template&id=c99fab50&scoped=true&"
import script from "./dailyIncrease.vue?vue&type=script&lang=js&"
export * from "./dailyIncrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99fab50",
  null
  
)

export default component.exports